import axios from 'axios'
import { ANALYSIS_DATA_PROJECTION, validateAnalysisDataProjection } from '@/utils/analysisDataStatus'

const API_BASE = process.env.VUE_APP_API_URL || '/api'
const COVERAGE_PATH = '/hddb/core-index-history/coverage'
const COVERAGE_ROUTE = '/api/hddb/core-index-history/coverage'
const CONTRACT_VERSION = 'core_index_history_coverage_rest_v1_20260802'

const client = axios.create({
  baseURL: API_BASE,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' }
})

client.interceptors.response.use(
  response => response.data,
  error => {
    const message = (error.response && error.response.data && error.response.data.detail) || error.message || '核心指数请求失败'
    return Promise.reject(new Error(message))
  }
)

function nonNegativeNumber(value) {
  return typeof value === 'number' && value >= 0
}

function validatePayload(payload) {
  const route = payload && payload.http_route_summary
  const safety = payload && payload.safety_summary
  const summary = payload && payload.summary
  const calendar = payload && payload.calendar_normalization_summary
  const valid = Boolean(
    payload &&
    payload.ok === true &&
    payload.data_status === 'official' &&
    summary &&
    summary.fixed_policy_count === 7 &&
    nonNegativeNumber(summary.pending_physical_verification_family_count) &&
    nonNegativeNumber(summary.confirmed_gap_family_count) &&
    nonNegativeNumber(summary.minimum_window_met_family_count) &&
    nonNegativeNumber(summary.running_family_count) &&
    Array.isArray(payload.items) &&
    payload.items.length === 7 &&
    calendar &&
    calendar.source === 'official_trade_cal_cache' &&
    calendar.provider_called_now === false &&
    calendar.writes_database === false &&
    route &&
    route.route === COVERAGE_ROUTE &&
    route.contract_version === CONTRACT_VERSION &&
    route.fixed_policy_count === 7 &&
    route.read_only === true &&
    route.cache_policy === 'no_store' &&
    route.new_mcp_tool_created === false &&
    route.writes_database === false &&
    route.creates_or_mutates_queue === false &&
    route.calls_provider === false &&
    route.downloads_data === false &&
    route.starts_worker === false &&
    route.starts_scheduler === false &&
    route.uses_official_trade_calendar_cache === true &&
    route.calendar_provider_called_now === false &&
    safety &&
    safety.read_only === true &&
    safety.writes_database === false &&
    safety.creates_or_mutates_queue === false &&
    safety.claims_or_refreshes_lease === false &&
    safety.calls_provider === false &&
    safety.downloads_data === false &&
    safety.starts_runtime === false &&
    safety.starts_worker === false &&
    safety.starts_scheduler === false &&
    safety.executes_ddl === false &&
    safety.reads_official_trade_calendar_cache === true &&
    safety.raw_rows_exposed === false &&
    safety.raw_task_keys_exposed === false
  )
  if (!valid) throw new Error('核心指数历史库只读合同校验失败')
  return payload
}

export const coreIndexHistoryApi = {
  async getCoverage() {
    return validatePayload(await client.get(COVERAGE_PATH, {
      params: { _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' }
    }))
  },
  async getAnalysisDataStatus() {
    const payload = await client.get(COVERAGE_PATH, {
      params: { projection: ANALYSIS_DATA_PROJECTION, _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
      timeout: 15000
    })
    return validateAnalysisDataProjection(payload, 'core_index')
  }
}

export function coreIndexHistoryErrorMessage(error, fallback) {
  return (error && error.message) || fallback || '核心指数请求失败'
}